import RequestEndorsementForm from "../components/requestEndorsement/main";

const RequestEndorsement = () => {
  return <RequestEndorsementForm />;
};

export default RequestEndorsement;
